import { ICompanyFilters } from "src/app/modules/logged/companies/store/types";

export class SetCurrentTab {
    static readonly type = '[company] set current tab';
    constructor(public tab?: 'GENERAL' | 'PROSPECTS', public filters?: Partial<ICompanyFilters>) { }
}

export class SetSearchField {
    static readonly type = '[company] set search field';
    constructor(public value: string) { }
}

export class SetFiltersBasedOnTab {
    static readonly type = '[company] set filters based on tab';
    constructor(public filters?: Partial<ICompanyFilters>) { }
}

export class ChangeTrackingEnabled {
    static readonly type = '[company] change tracking enable';
    constructor(public companyID: string, public status: boolean) { }
}

// TODO probably needs refactoring
export class FetchSearchAll {
    static readonly type = '[company] fetch search all';
    constructor(public data: any) { }
}